import { useState } from 'react';
import { useFormik } from 'formik';
import { useNavigate } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Form from 'react-bootstrap/Form';
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";

import { AppLayout } from "../components/appLayout";
import useApiClient from "../hooks/useApiClient";
import { CreateCategoryBindingModel } from "../apiClient";
import { getErrorMessage, getFieldError } from "../helpers/errorHelper";

interface FormValues {
    name: string;
}

export const CategoryAdd = () => {
    const apiClient = useApiClient();
    const navigate = useNavigate();
    const [generalError, setGeneralError] = useState<string | null>(null);

    const formik = useFormik<FormValues>({
        initialValues: {
            name: ''
        },
        onSubmit: async (values, helpers) => {
            setGeneralError(null);
            try {
                await apiClient?.categoriesPOST(new CreateCategoryBindingModel({
                    name: values.name
                }));
                navigate(`/categories`);
            } catch (error) {
                console.error(error);
                const nameError = getFieldError(error, 'Name') ?? getFieldError(error, 'name');
                if (nameError) {
                    helpers.setFieldError('name', nameError);
                } else {
                    setGeneralError(getErrorMessage(error));
                }
            } finally {
                helpers.setSubmitting(false);
            }
        },
    });

    return (
        <AppLayout>
            <Container className="py-2">
                <Breadcrumb>
                    <LinkContainer to={`/categories`}>
                        <Breadcrumb.Item>Categories</Breadcrumb.Item>
                    </LinkContainer>
                    <Breadcrumb.Item active>Add category</Breadcrumb.Item>
                </Breadcrumb>

                <div className="mb-3">
                    <h1 className="mb-1">Add category</h1>
                </div>

                {generalError && (
                    <Alert variant="danger" className="py-2 mb-3">
                        {generalError}
                    </Alert>
                )}

                <Card>
                    <Card.Body className="p-4">
                        <Form onSubmit={formik.handleSubmit} noValidate>
                            <fieldset disabled={formik.isSubmitting}>
                                <Form.Group className="mb-3" controlId="category-add-name">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        required={true}
                                        name="name"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                        isInvalid={formik.touched.name && !!formik.errors.name}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {formik.errors.name}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </fieldset>

                            <Button variant="primary" type="submit" disabled={!formik.values.name.trim() || formik.isSubmitting}>
                                Add category
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>
        </AppLayout>
    );
};